import { ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import "@enersis/gp-components/gp-spinner";

export type SkeletonEffect = "pulse" | "sheen";

@Component({
  selector: "tpm-spinner",
  templateUrl: "spinner.component.html",
  styleUrls: ["spinner.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SpinnerComponent {}
